import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TradeEditDeleteLogLayer from "../../components/Utilities/TradeEditDeleteLogLayer";

const TradeEditDeleteLogPage = () => {
  return (
    <MasterLayout>
      <TradeEditDeleteLogLayer />
    </MasterLayout>
  );
};

export default TradeEditDeleteLogPage;
